import React, { useState, useRef } from 'react';

import Modal from 'components/shared/Modal';
import Button from 'components/shared/Button';
import Alert from 'components/shared/Alert';

import type { Project, ProjectSaveParams } from 'domains/projects';

type SaveProjectModalProps = {
  cartProject?: Project;
  onSave: (project: ProjectSaveParams) => void;
  onClose: () => void;
};

function SaveProjectModal(props: SaveProjectModalProps) {
  const { cartProject, onSave, onClose } = props;

  const [showAlert, setShowAlert] = useState(false);
  const nameInput = useRef<HTMLInputElement>(null);

  const [name, setName] = useState(cartProject?.name || '');
  const [description, setDescription] = useState(cartProject?.description || undefined);

  function saveAndCloseModal() {
    onSave({ guid: cartProject?.guid, id: cartProject?.id, name, description });
    onClose();
  }

  function handleUpdate() {
    if (cartProject) {
      setShowAlert(true);
      return;
    }

    saveAndCloseModal();
  }

  function handleContinue() {
    setShowAlert(false);
    saveAndCloseModal();
  }

  function handleCancel() {
    setTimeout(() => nameInput.current?.focus(), 0); // unfortunate hack to get around react's rendering cycle
    setShowAlert(false);
  }

  const saveProjectButtons = (
    <React.Fragment>
      <Button type="confirm" onClick={handleUpdate}>
        Save
      </Button>
      <Button type="cancel" onClick={onClose}>
        Cancel
      </Button>
    </React.Fragment>
  );

  return (
    <Modal
      title="Save Your Project"
      labelledBy="save-project-modal"
      lastFocusedElementId="projects-menu-trigger"
      onClose={onClose}
      primaryFooterGroup={saveProjectButtons}
    >
      <div className="save-project-form">
        {showAlert && (
          <Alert
            title="Save Project"
            labelledBy="save-project-alert-modal"
            lastFocusedElementId="save_project_name"
            onClose={() => setShowAlert(false)}
            message={'Are you sure you want to overwrite the current project?'}
            onContinue={handleContinue}
            onCancel={handleCancel}
          />
        )}
        <div className="save-project-fields">
          <label htmlFor="save_project_name">Project Name</label>
          <input
            type="text"
            id="save_project_name"
            name="save-project-name"
            ref={nameInput}
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <label htmlFor="save_project_description">Project Description</label>
          <textarea
            id="save_project_description"
            rows={1}
            name="save-project-description"
            onChange={(e) => setDescription(e.target.value)}
            value={description}
          />
        </div>
      </div>
    </Modal>
  );
}

export default SaveProjectModal;
